import { Readable } from 'generated/apolloComponents'
import SingleReadable from './Single'
import SingleNoPhotoReadable from './SingleNoPhoto'

interface IProps {
  readable: Readable
}

const ThemeSelector = ({ readable }: IProps) => {
  if (readable.contentType === 'article_no_photo')
    return <SingleNoPhotoReadable readable={readable} />
  return <SingleReadable readable={readable} />
}
export default ThemeSelector
